import { api } from "@/lib/api";

// Public, safe company fields for pages like Palvelumme.
export async function fetchPublicCompany() {
  const { data } = await api.get("/company/public");
  return data.company;
}

// Founder-only: full company settings document.
export async function fetchCompanySettings() {
  const { data } = await api.get("/company/settings");
  return data.company;
}

export async function updateCompanySettings(payload) {
  const { data } = await api.put("/company/settings", payload);
  return data.company;
}
